import Loading from '@cartwhl/ui/atoms/Loading';
import Text from '@cartwhl/ui/base/Text';

export default function LoadingCharacter() {
  return (
    <div className="flex h-full w-full items-center justify-center">
      <div className="dark:bg-gray-90 flex flex-col items-center justify-center gap-2 rounded-lg bg-white p-4 dark:text-white">
        <Loading />
        <Text as="p" variant="studio/body/sm">
          Loading character...
        </Text>
      </div>
    </div>
  );
}
